import { render, staticRenderFns } from "./HeaderSwitch.vue?vue&type=template&id=b93f23fa&"
import script from "./HeaderSwitch.vue?vue&type=script&lang=js&"
export * from "./HeaderSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports